import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import styled from 'styled-components';
const Container = styled.button `
  ${ButtonReset};

  display: grid;
  place-content: flex-end;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: ${brand.primary.white};
  border-radius: inherit;

  &::before {
    ${transition('opacity')};

    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(36, 36, 39, 0.25) 0%,
      rgba(36, 36, 39, 0.32) 45%,
      rgba(36, 36, 39, 0.92) 100%
    );
    mix-blend-mode: multiply;
  }

  &:focus-visible {
    outline: auto;
    outline-color: currentColor;
    outline-offset: -5px;
    outline-width: thin;
  }

  &:focus-visible,
  &:hover {
    &::before {
      opacity: 0.8;
    }
  }

  > svg {
    position: absolute;
    left: 0;
    bottom: 0;
    width: ${fluid(176, 352)};
    opacity: 0.16;
    mix-blend-mode: overlay;
    transform: translate(-30%, 18%) rotate(226deg);
    z-index: -2;
  }
`;
const TextWrapper = styled.div `
  display: flex;
  gap: ${fluid(14, 20)};
  align-items: center;
  text-align: right;
  padding: ${fluid(16, 32)};
`;
const Text = styled.span `
  ${transition('opacity')};

  ${fonts.poppins.regular};

  font-size: ${fluid(14, 20)};
  line-height: ${fluid(18, 24)};
  text-wrap: balance;
  max-width: 208px;

  span {
    font-weight: 600;
  }

  ${Container}:focus-visible &,
  ${Container}:hover & {
    opacity: 0.8;
  }
`;
const Icon = styled.div `
  ${transition('transform')};

  display: flex;
  place-content: center;
  width: ${fluid(44, 60)};
  padding-left: 5px;
  aspect-ratio: 1;
  border: 3px solid currentColor;
  border-radius: 5000px;

  svg {
    display: block;
    width: 66%;
  }

  ${Container}:focus-visible &,
  ${Container}:hover & {
    transform: scale(1.1);
  }
`;
const VideoPromptStyles = {
    Container,
    Text,
    TextWrapper,
    Icon,
};
export default VideoPromptStyles;
